export const defineVxeComponent = ((options) => options);
